// Chapter timestamps (in seconds) for KJV audio YouTube videos
// Generated by youtube_modal/extract_chapters.py from YouTube transcripts
// To add more books: python extract_chapters.py <transcript.txt or .vtt> <abbrev>
//
// Single-chapter books (ob, phm, 2jo, 3jo, jd) start at 0s

const youtubeChapterTimestamps = {
  '1ch': { 2: 271, 3: 598, 4: 747, 5: 1060, 6: 1275, 7: 1704, 8: 2001, 9: 2205, 10: 2516, 
    11: 2633, 12: 2944, 13: 3255, 14: 3368, 15: 3489, 16: 3725, 17: 4015, 18: 4273, 
    19: 4409, 20: 4596, 21: 4682, 22: 4962, 23: 5156, 24: 5372, 25: 5562, 27: 5988, 
    28: 6249, 29: 6497 },
  '1co': { 1: 5, 2: 246, 3: 387, 4: 572, 5: 768, 6: 885, 7: 1150, 8: 1426, 9: 1540, 
    10: 1785, 11: 2046, 12: 2313, 13: 2563, 14: 2711, 15: 3046, 16: 3492 },
  '1jo': { 1: 3, 2: 91, 3: 352, 4: 557, 5: 745 },
  '1kgs': { 2: 472, 3: 961, 4: 1242, 5: 1491, 6: 1655, 7: 1980, 8: 2432, 9: 3175, 
    10: 3446, 11: 3719, 12: 4125, 13: 4455, 14: 4788, 15: 5100, 16: 5390, 17: 5698, 
    18: 5910, 19: 6385, 20: 6639, 21: 7094, 22: 7382 },
  '1pe': { 1: 5, 2: 233, 3: 458, 4: 667, 5: 859 },
  '1sm': { 2: 248, 3: 613, 4: 804, 5: 1045, 6: 1172, 7: 1426, 8: 1603, 9: 1781, 10: 2095, 
    11: 2387, 12: 2533, 13: 2797, 14: 3011, 15: 3508, 16: 3854, 17: 4086, 18: 4595, 
    19: 4869, 20: 5091, 21: 5492, 22: 5648, 23: 5875, 24: 6136, 25: 6355, 26: 6797, 
    27: 7082, 28: 7203, 29: 7488, 30: 7612, 31: 7877 },
  '1tm': { 1: 3, 2: 172, 3: 269, 4: 390, 5: 515, 6: 702 },
  '1ts': { 1: 6, 2: 89, 3: 257, 4: 353, 5: 491 },
  '2ch': { 2: 175, 3: 378, 4: 530, 5: 715, 6: 870, 7: 1344, 8: 1593, 9: 1750, 10: 2029, 
    11: 2203, 12: 2370, 13: 2537, 14: 2753, 15: 2894, 16: 3047, 17: 3207, 18: 3359, 
    19: 3684, 20: 3797, 21: 4171, 22: 4365, 23: 4498, 24: 4722, 25: 5004, 26: 5297, 
    27: 5528, 28: 5601, 29: 5889, 30: 6247, 31: 6532, 32: 6772, 33: 7118, 34: 7368, 
    35: 7721, 36: 7993 },
  '2co': { 1: 5, 2: 219, 3: 360, 4: 508, 5: 666, 6: 851, 7: 1005, 8: 1180, 9: 1376, 
    10: 1504, 11: 1657, 12: 1947, 13: 2169 },
  '2kgs': { 2: 204, 3: 476, 4: 743, 5: 1172, 6: 1492, 7: 1816, 8: 2062, 9: 2361, 
    10: 2732, 11: 3000, 12: 3329, 13: 3529, 14: 3792, 15: 4069, 16: 4410, 17: 4607, 
    18: 5027, 19: 5415, 20: 5810, 21: 6018, 22: 6250, 23: 6462, 24: 6907, 25: 7094 },
  '2pe': { 1: 5, 2: 187, 3: 419 },
  '2sm': { 2: 238, 3: 536, 4: 902, 5: 1022, 6: 1233, 7: 1435, 8: 1738, 9: 1886, 10: 2024, 
    11: 2200, 12: 2468, 13: 2802, 14: 3156, 15: 3501, 16: 3860, 18: 4392, 19: 4800, 
    20: 5198, 21: 5463, 22: 5702, 23: 6038, 24: 6319 },
  '2tm': { 1: 3, 2: 154, 3: 349, 4: 486 },
  '2ts': { 1: 4, 2: 98, 3: 236 },
  act: { 1: 3, 2: 230, 3: 602, 4: 836, 5: 1127, 6: 1477, 7: 1600, 8: 2086, 9: 2381, 
    10: 2756, 11: 3153, 12: 3379, 13: 3599, 14: 4057, 15: 4273, 16: 4585, 17: 4885, 
    18: 5183, 19: 5414, 20: 5743, 22: 6389, 23: 6648, 24: 6938, 25: 7153, 26: 7382, 
    27: 7657, 28: 7984 },
  am: { 1: 1, 2: 136, 3: 278, 4: 406, 5: 557, 6: 778, 7: 902, 8: 1053, 9: 1181 },
  cl: { 1: 6, 2: 224, 3: 411, 4: 593 },
  dn: { 1: 2, 2: 180, 3: 657, 4: 982, 5: 1408, 6: 1727, 7: 2010, 8: 2321, 9: 2594, 
    10: 2917, 11: 3131, 12: 3582 },
  dt: { 2: 424, 3: 743, 4: 1007, 5: 1505, 6: 1772, 7: 1986, 8: 2254, 9: 2443, 10: 2747, 
    11: 2939, 12: 3224, 13: 3539, 14: 3730, 15: 3950, 16: 4171, 17: 4386, 18: 4593, 
    19: 4782, 20: 4971, 21: 5167, 22: 5384, 23: 5653, 24: 5883, 25: 6085, 26: 6262, 
    27: 6463, 28: 6670, 29: 7341, 30: 7604, 31: 7808, 32: 8133, 33: 8592, 34: 8859 },
  ec: { 2: 144, 3: 418, 4: 608, 5: 756, 6: 941, 7: 1044, 8: 1270, 9: 1439, 10: 1648, 
    11: 1791, 12: 1889 },
  eph: { 1: 5, 2: 168, 3: 347, 4: 487, 5: 715, 6: 936 },
  et: { 2: 219, 3: 471, 4: 639, 5: 808, 6: 961, 7: 1104, 8: 1207, 9: 1403, 10: 1710 },
  ex: { 1: 0, 2: 172, 3: 394, 4: 696, 5: 992, 6: 1197, 7: 1455, 8: 1680, 9: 1987, 
    10: 2299, 11: 2591, 12: 2706, 13: 3198, 14: 3420, 15: 3720, 16: 3985, 17: 4324, 
    18: 4475, 19: 4708, 20: 4933, 21: 5126, 22: 5402, 23: 5647, 24: 5924, 26: 6374, 
    27: 6664, 28: 6847, 29: 7238, 30: 7654, 31: 7968, 32: 8115, 33: 8464, 34: 8692, 
    35: 9027, 36: 9292, 37: 9562, 38: 9779, 39: 10037, 40: 10357 },
  ez: { 1: 3, 2: 257, 3: 348, 4: 592, 5: 757, 6: 963, 7: 1118, 8: 1385, 9: 1591, 
    10: 1716, 11: 1915, 12: 2126, 13: 2377, 14: 2619, 15: 2845, 16: 2907, 18: 3762, 
    19: 4082, 21: 4703, 22: 5021, 23: 5297, 24: 5743, 25: 5996, 26: 6154, 27: 6373, 
    28: 6684, 29: 6946, 30: 7156, 31: 7373, 32: 7572, 33: 7887, 34: 8223, 35: 8520, 
    36: 8639, 37: 9000, 38: 9269, 39: 9495, 40: 9772, 41: 10197, 42: 10417, 43: 10576, 
    44: 10828, 45: 11126, 46: 11375, 47: 11614, 48: 11839 },
  ezr: { 2: 113, 3: 432, 4: 599, 6: 995, 7: 1234, 8: 1483, 9: 1808, 10: 2024 },
  gl: { 1: 5, 2: 160, 3: 358, 4: 602, 5: 825, 6: 1009 },
  gn: { 1: 9, 2: 306, 3: 512, 4: 740, 5: 957, 6: 1134, 7: 1324, 8: 1512, 9: 1720, 
    10: 1920, 11: 2127, 12: 2332, 13: 2500, 14: 2644, 15: 2836, 16: 3002, 17: 3146, 
    18: 3370, 19: 3640, 20: 3964, 21: 4134, 22: 4384, 23: 4605, 24: 4762, 26: 5545, 
    27: 5817, 28: 6211, 29: 6411, 30: 6659, 31: 6983, 32: 7429, 33: 7676, 34: 7849, 
    35: 8077, 36: 8299, 37: 8598, 38: 8900, 39: 9157, 40: 9346, 41: 9517, 42: 9987, 
    43: 10315, 44: 10630, 45: 10894, 46: 11149, 47: 11409, 48: 11737, 49: 11968, 50: 12280 },
  hb: { 1: 3, 2: 120, 3: 286, 4: 415, 5: 554, 6: 667, 7: 810, 8: 1026, 9: 1145, 10: 1379, 
    11: 1666, 12: 2028, 13: 2274 },
  hg: { 1: 0, 2: 138 },
  hk: { 1: 0, 2: 152, 3: 344 },
  ho: { 1: 1, 2: 108, 3: 311, 4: 359, 5: 522, 6: 639, 7: 726, 8: 854, 9: 966, 10: 1127, 
    11: 1272, 12: 1374, 13: 1478, 14: 1617 },
  is: { 2: 286, 3: 470, 4: 694, 5: 764, 6: 1071, 7: 1217, 9: 1640, 10: 1844, 12: 2350, 
    13: 2403, 14: 2603, 15: 2921, 16: 3025, 17: 3189, 18: 3341, 19: 3431, 20: 3681, 
    21: 3747, 22: 3898, 23: 4125, 24: 4301, 25: 4515, 26: 4656, 27: 4864, 28: 5005, 
    29: 5278, 30: 5531, 31: 5889, 32: 5999, 33: 6164, 34: 6390, 35: 6559, 36: 6659, 
    37: 6882, 38: 7259, 39: 7453, 40: 7532, 41: 7817, 42: 8113, 43: 8364, 44: 8610, 
    45: 8940, 46: 9219, 47: 9348, 48: 9528, 49: 9732, 50: 10013, 51: 10131, 52: 10382, 
    53: 10529, 54: 10664, 55: 10832, 56: 10964, 57: 11088, 58: 11294, 60: 11684, 
    61: 11916, 63: 12176, 64: 12359, 66: 12732 },
  jl: { 1: 2, 2: 176, 3: 495 },
  jm: { 1: 3, 2: 203, 3: 400, 4: 550, 5: 693 },
  jn: { 1: 0, 2: 146, 3: 218, 4: 299 },
  jo: { 1: 5, 2: 371, 3: 542, 4: 824, 5: 1201, 6: 1548, 7: 2064, 8: 2406, 9: 2870, 
    10: 3172, 11: 3457, 12: 3870, 13: 4248, 14: 4561, 15: 4836, 16: 5063, 17: 5345, 
    18: 5569, 19: 5899, 20: 6254, 21: 6514 },
  job: { 2: 213, 3: 333, 4: 489, 5: 608, 6: 759, 7: 926, 8: 1000, 9: 1185, 10: 1380, 
    11: 1518, 12: 1630, 13: 1773, 14: 1917, 15: 2064, 16: 2246, 17: 2380, 18: 2473, 
    19: 2572, 20: 2747, 21: 2903, 22: 3067, 23: 3245, 24: 3346, 25: 3517, 26: 3549, 
    27: 3631, 28: 3756, 29: 3910, 30: 4046, 31: 4229, 32: 4453, 33: 4568, 34: 4744, 
    35: 4948, 36: 5037, 37: 5214, 38: 5352, 39: 5615, 40: 5790, 41: 5928, 42: 6118 },
  jr: { 1: 3, 2: 166, 3: 531, 4: 812, 5: 1125, 6: 1439, 7: 1737, 8: 2053, 9: 2299, 
    10: 2560, 11: 2776, 12: 3005, 13: 3191, 14: 3446, 15: 3696, 16: 3919, 17: 4130, 
    18: 4394, 19: 4605, 20: 4784, 21: 4972, 22: 5124, 23: 5419, 24: 5815, 25: 5921, 
    26: 6280, 27: 6517, 28: 6744, 29: 6913, 30: 7225, 31: 7469, 32: 7905, 33: 8331, 
    34: 8597, 35: 8844, 36: 9043, 37: 9361, 39: 9841, 40: 10006, 41: 10202, 42: 10385, 
    43: 10589, 44: 10714, 45: 11065, 47: 11372, 48: 11443, 49: 11840, 50: 12217, 
    51: 12703, 52: 13319 },
  js: { 2: 166, 3: 382, 4: 553, 5: 760, 6: 930, 7: 1187, 8: 1476, 9: 1828, 10: 2028, 
    11: 2498, 12: 2714, 13: 2847, 14: 3111, 15: 3260, 16: 3615, 17: 3699, 18: 3884, 
    19: 4126, 20: 4463, 21: 4556, 22: 4866, 23: 5264, 24: 5447 },
  jud: { 2: 305, 3: 533, 4: 805, 5: 1047, 6: 1320, 7: 1712, 8: 2000, 9: 2305, 10: 2792, 
    11: 2942, 12: 3309, 13: 3442, 14: 3675, 15: 3884, 16: 4071, 17: 4394, 18: 4508, 
    19: 4775, 20: 5085, 21: 5478 },
  lk: { 1: 3, 2: 528, 3: 896, 5: 1528, 6: 1836, 7: 2256, 8: 2671, 9: 3140, 10: 3650, 
    11: 4014, 12: 4484, 13: 4998, 14: 5307, 15: 5575, 16: 5827, 17: 6096, 18: 6382, 
    19: 6700, 20: 7029, 21: 7370, 22: 7672, 23: 8175, 24: 8564 },
  lm: { 1: 3, 2: 289, 3: 586, 4: 885, 5: 1092 },
  lv: { 1: 0, 2: 160, 3: 309, 4: 452, 5: 764, 6: 970, 7: 1235, 8: 1546, 9: 1850, 
    10: 2038, 11: 2250, 12: 2617, 13: 2695, 14: 3234, 15: 3706, 16: 3977, 17: 4310, 
    18: 4495, 19: 4730, 20: 5054, 21: 5316, 22: 5510, 23: 5802, 24: 6194, 25: 6380, 
    26: 6849, 27: 7289 },
  mi: { 1: 0, 2: 148, 3: 275, 4: 385, 5: 535, 6: 674, 7: 820 },
  mk: { 1: 4, 2: 307, 3: 536, 4: 761, 5: 1064, 6: 1372, 7: 1768, 8: 2039, 9: 2320, 
    10: 2719, 11: 3131, 12: 3389, 13: 3772, 14: 4075, 15: 4613, 16: 4928 },
  ml: { 1: 2, 2: 160, 3: 337, 4: 522 },
  mt: { 1: 8, 2: 187, 3: 398, 4: 539, 5: 741, 6: 1127, 7: 1416, 8: 1633, 9: 1888, 
    10: 2183, 11: 2516, 12: 2759, 13: 3153, 14: 3638, 15: 3872, 16: 4158, 17: 4392, 
    19: 4914, 20: 5178, 21: 5430, 22: 5817, 23: 6114, 24: 6452, 25: 6818, 26: 7157, 
    27: 7734, 28: 8201 },
  na: { 1: 1, 2: 132, 3: 253 },
  ne: { 2: 125, 3: 335, 4: 643, 5: 866, 6: 1064, 7: 1252, 8: 1637, 9: 1868, 10: 2346, 
    11: 2574, 12: 2838, 13: 3171 },
  nm: { 2: 396, 3: 648, 4: 1042, 5: 1454, 6: 1727, 7: 1958, 8: 2515, 9: 2730, 10: 2944, 
    11: 3220, 12: 3567, 13: 3695, 14: 3913, 15: 4291, 16: 4612, 17: 5041, 18: 5154, 
    19: 5488, 20: 5706, 21: 5958, 22: 6240, 23: 6593, 24: 6834, 25: 7055, 26: 7184, 
    27: 7643, 28: 7824, 29: 8059, 30: 8335, 31: 8474, 32: 8838, 33: 9144, 34: 9435, 
    35: 9618, 36: 9907 },
  ph: { 1: 4, 2: 231, 3: 451, 4: 635 },
  prv: { 2: 201, 3: 324, 4: 531, 5: 686, 6: 834, 7: 1046, 8: 1199, 9: 1424, 10: 1542, 
    11: 1757, 12: 1972, 13: 2152, 14: 2322, 15: 2544, 16: 2740, 17: 2945, 18: 3139, 
    19: 3295, 20: 3500, 21: 3691, 22: 3899, 23: 4078, 24: 4294, 25: 4514, 26: 4720, 
    27: 4904, 28: 5095, 29: 5299, 30: 5476, 31: 5713 },
  ps: { 2: 37, 3: 109, 4: 157, 5: 219, 6: 300, 7: 361, 8: 474, 9: 537, 10: 668, 11: 790, 
    12: 845, 13: 898, 14: 940, 15: 996, 16: 1045, 17: 1116, 18: 1226, 19: 1540, 20: 1635, 
    21: 1694, 22: 1780, 23: 1980, 24: 2018, 25: 2091, 26: 2214, 27: 2283, 28: 2384, 
    29: 2458, 30: 2519, 31: 2614, 32: 2785, 33: 2870, 34: 2985, 35: 3095, 36: 3290, 
    37: 3379, 38: 3623, 39: 3749, 40: 3849, 41: 3990, 42: 4080, 43: 4188, 44: 4229, 
    45: 4380, 46: 4501, 47: 4578, 48: 4628, 49: 4707, 50: 4850, 51: 5004, 52: 5147, 
    53: 5213, 54: 5260, 55: 5310, 56: 5457, 57: 5544, 58: 5627, 59: 5713, 60: 5828, 
    61: 5911, 62: 5959, 63: 6064, 64: 6130, 65: 6194, 66: 6294, 67: 6406, 68: 6449, 
    69: 6722, 70: 6954, 71: 6994, 72: 7172, 73: 7304, 74: 7460, 75: 7635, 76: 7700, 
    77: 7777, 78: 7910, 79: 8362, 80: 8460, 81: 8578, 82: 8681, 83: 8737, 84: 8834, 
    85: 8932, 86: 9006, 87: 9117, 88: 9165, 89: 9273, 90: 9572, 91: 9705, 92: 9798, 
    93: 9886, 94: 9926, 95: 10062, 96: 10126, 97: 10208, 98: 10282, 99: 10342, 
    100: 10397, 101: 10438, 102: 10493, 103: 10650, 104: 10781, 105: 11006, 106: 11230, 
    107: 11520, 108: 11780, 109: 11855, 110: 12050, 111: 12094, 112: 12156, 113: 12227, 
    114: 12268, 115: 12316, 116: 12415, 117: 12519, 118: 12537, 119: 12707, 120: 13661, 
    121: 13692, 122: 13732, 123: 13783, 124: 13824, 125: 13868, 126: 13904, 127: 13948, 
    128: 14000, 129: 14029, 130: 14079, 131: 14133, 132: 14157, 133: 14267, 134: 14294, 
    135: 14319, 136: 14439, 137: 14564, 139: 14698, 140: 14847, 141: 14942, 142: 15014, 
    143: 15074, 144: 15172, 145: 15292, 146: 15415, 147: 15497, 148: 15615, 149: 15704, 
    150: 15758 },
  re: { 1: 4, 2: 224, 3: 516, 4: 740, 5: 860, 6: 1005, 7: 1183, 8: 1352, 9: 1491, 
    10: 1688, 11: 1808, 12: 2008, 13: 2179, 14: 2359, 15: 2572, 16: 2659, 17: 2849, 
    18: 3041, 19: 3326, 20: 3549, 21: 3708, 22: 3985 },
  rm: { 1: 4, 2: 273, 3: 516, 4: 737, 5: 936, 6: 1124, 7: 1311, 8: 1534, 9: 1872, 
    10: 2139, 11: 2315, 12: 2624, 13: 2806, 14: 2951, 15: 3156, 16: 3409 },
  rt: { 2: 202, 3: 434, 4: 589 },
  so: { 1: 2, 3: 242, 4: 336, 5: 473, 6: 616, 7: 718, 8: 817 },
  tt: { 1: 3, 2: 126, 3: 236 },
  zc: { 1: 2, 2: 199, 3: 297, 4: 393, 5: 507, 6: 608, 7: 733, 8: 849, 9: 1069, 10: 1242, 
    11: 1363, 12: 1517, 13: 1658, 14: 1764 },
  zp: { 1: 2, 2: 175, 3: 341 },
};

export default youtubeChapterTimestamps;
